// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27 fill=%27%23666%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z%27 clip-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.case-list-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.no-records-found {
  text-align: center;
  font-size: 1rem;
  color: var(--text-color-medium);
  padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);
  background: var(--card-bg);
  border-radius: 0.75rem;
  border: 1px dashed var(--border-color);
  margin-top: calc(var(--spacing-unit) * 2);
  grid-column: 1/-1;
}

.filter-one-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.filter-one-row input {
  width: 49%;
}

.select-all-container {
  margin-top: 10px;
  margin-left: auto;
  display: flex;
  align-items: center;
}
.select-all-container label {
  margin-left: 5px;
  font-size: 15px;
}

.cases-options {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  flex-wrap: wrap;
}
.cases-options .manage-cases-btn,
.cases-options .assign-cases-btn {
  padding: 8px 18px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
}
.cases-options .lawyer-select-container {
  position: relative;
}
.cases-options .lawyer-select-container .select-lawyer-btn {
  padding: 8px 18px;
  background: var(--success-color);
  color: white;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 5px;
}
.cases-options .lawyer-select-container .select-lawyer-btn:active {
  transform: scale(0.98);
}
.cases-options .lawyer-select-container .lawyer-dropdown {
  position: fixed; /* Changed from absolute to fixed like filter dropdown */
  /* top and left will be set dynamically via inline styles */
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  min-width: 320px;
  max-width: 400px;
  z-index: 1000;
  max-height: 500px;
  overflow: hidden;
  animation: slideDown 0.2s ease-out;
  margin-left: 44px;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-search-input {
  width: 100%;
  padding: 12px 16px;
  border: none;
  border-bottom: 1px solid #e5e7eb;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
  background: #fafafa;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-search-input::placeholder {
  color: #9ca3af;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-search-input:focus {
  border-bottom-color: #3b82f6;
  background: white;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-options {
  max-height: 180px;
  overflow-y: auto;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-options .lawyer-option {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  transition: all 0.15s ease;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-options .lawyer-option:hover {
  background: #f8fafc;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-options .lawyer-option.focused {
  background: #dbeafe;
  border-left: 3px solid #3b82f6;
  padding-left: 13px;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-options .lawyer-option:last-child {
  border-bottom: none;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-options .lawyer-option input[type=checkbox] {
  margin-right: 12px;
  transform: scale(1.1);
  cursor: pointer;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-options .lawyer-option .lawyer-name {
  font-size: 14px;
  font-weight: 500;
  margin-right: 8px;
  color: #1f2937;
  flex: 1 1;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-options .lawyer-option .lawyer-email {
  color: #6b7280;
  font-size: 12px;
  font-style: italic;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-options::-webkit-scrollbar {
  width: 6px;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-options::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-options::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-options::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.cases-options .lawyer-select-container .lawyer-dropdown .selected-lawyers {
  padding: 12px 16px;
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;
}
.cases-options .lawyer-select-container .lawyer-dropdown .selected-lawyers h4 {
  margin: 0 0 10px 0;
  font-size: 13px;
  color: #374151;
  font-weight: 600;
}
.cases-options .lawyer-select-container .lawyer-dropdown .selected-lawyers .selected-lawyers-list {
  max-height: 80px;
  overflow-y: auto;
}
.cases-options .lawyer-select-container .lawyer-dropdown .selected-lawyers .selected-lawyers-list::-webkit-scrollbar {
  width: 4px;
}
.cases-options .lawyer-select-container .lawyer-dropdown .selected-lawyers .selected-lawyers-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}
.cases-options .lawyer-select-container .lawyer-dropdown .selected-lawyers .selected-lawyers-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}
.cases-options .lawyer-select-container .lawyer-dropdown .selected-lawyers .selected-lawyers-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.cases-options .lawyer-select-container .lawyer-dropdown .selected-lawyers .selected-lawyer-tag {
  display: inline-flex;
  align-items: center;
  background: #dbeafe;
  color: #1e40af;
  padding: 4px 10px;
  border-radius: 16px;
  margin: 2px 4px 2px 0;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid #bfdbfe;
  animation: tagAppear 0.2s ease-out;
}
.cases-options .lawyer-select-container .lawyer-dropdown .selected-lawyers .selected-lawyer-tag button {
  background: none;
  border: none;
  color: #1e40af;
  margin-left: 6px;
  cursor: pointer;
  padding: 0 2px;
  font-size: 14px;
  font-weight: bold;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
  line-height: 1;
}
.cases-options .lawyer-select-container .lawyer-dropdown .selected-lawyers .selected-lawyer-tag button:hover {
  background: #1e40af;
  color: white;
}
.cases-options .lawyer-select-container .lawyer-dropdown .assign-action {
  padding: 12px 16px;
  border-top: 1px solid #e5e7eb;
  background: #ffffff;
}
.cases-options .lawyer-select-container .lawyer-dropdown .assign-action .assign-cases-final-btn {
  width: 100%;
  padding: 8px 18px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.cases-options .lawyer-select-container .lawyer-dropdown .assign-action .assign-cases-final-btn:active:not(:disabled) {
  transform: translateY(0);
}
.cases-options .lawyer-select-container .lawyer-dropdown .assign-action .assign-cases-final-btn:disabled {
  background: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.filter-tab .filter-dropdown-box .filter-group {
  gap: 5px;
}
.filter-tab .main-case-filter-dropdown-box .main-case-filter-filter-group {
  width: 49%;
}
.filter-tab .filter-dropdown-box {
  min-width: 320px;
  max-width: 400px;
}
.filter-tab .filter-dropdown-box.customer-filters {
  min-width: 280px;
  max-width: 350px;
}
.filter-tab .filter-dropdown-box.customer-filters .page-filter .main-case-filter-filter-group {
  width: 100%;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes tagAppear {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes pulse {
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}
.hammer-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.hammer-loader .hammer {
  font-size: 40px;
  margin-bottom: 16px;
  animation: hammer 1s ease-in-out infinite;
  transform-origin: bottom center;
}
.hammer-loader .anvil {
  font-size: 24px;
  margin-bottom: 16px;
  animation: anvil-shake 1s ease-in-out infinite;
}

.pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
  gap: 10px;
}
.pagination-controls button {
  padding: 6px 12px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  min-width: 80px;
  text-align: center;
}
.pagination-controls button:disabled {
  background: var(--primary-color);
  cursor: not-allowed;
  opacity: 0.6;
}

.page-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
}

.pagination-settings {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  font-weight: 500;
  padding: 7px 18px;
  background-color: #E2E8F0;
  border-radius: 6px;
}
.pagination-settings label {
  white-space: nowrap;
  color: #1f2937;
  font-size: 14px;
  font-weight: 600;
}
.pagination-settings #casesPerPageSelect {
  border: none !important;
  border-radius: 6px;
  outline: none;
  padding: 6px 32px 6px 12px;
  background-color: white;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  min-width: 70px;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
  transition: all 0.2s ease;
  box-shadow: none !important;
}
.pagination-settings #casesPerPageSelect:hover {
  background-color: #fafafa;
}
.pagination-settings #casesPerPageSelect:focus {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
  background-color: white;
}
.pagination-settings #casesPerPageSelect option {
  border: none !important;
  outline: none;
  padding: 4px 8px;
}

.filter-group .radio-group {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.radio-option {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333;
}

.radio-option input[type=radio] {
  margin-right: 6px;
}

@keyframes hammer {
  0%, 100% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-45deg);
  }
  50% {
    transform: rotate(-90deg);
  }
  75% {
    transform: rotate(-45deg);
  }
}
@keyframes anvil-shake {
  0%, 100% {
    transform: translateX(0);
  }
  25%, 75% {
    transform: translateX(-2px);
  }
  50% {
    transform: translateX(2px);
  }
}
@media (max-width: 768px) {
  .cases-options {
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
  .cases-options .lawyer-select-container .lawyer-dropdown {
    left: 50%;
    transform: translateX(-50%);
    min-width: 280px;
    max-width: 90vw;
  }
  .cases-options .lawyer-select-container .lawyer-dropdown .selected-lawyers .selected-lawyers-list {
    max-height: 60px;
  }
  .cases-options .lawyer-select-container .lawyer-dropdown .assign-action .assign-cases-final-btn {
    font-size: 13px;
    padding: 8px 12px;
  }
  .page-filter {
    flex-direction: column;
    gap: 10px;
    align-items: stretch;
  }
  .pagination-settings {
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/CaseList/CaseList.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAGA;EACE,kBAAA;EACA,eAAA;EACA,+BAAA;EACA,oEAAA;EACA,0BAAA;EACA,sBAAA;EACA,sCAAA;EAEA,yCAAA;EACA,iBAAA;AADF;;AAKA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;AAFF;AAKE;EACE,UAAA;AAHJ;;AAQA;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AALF;AAQE;EACE,gBAAA;EACA,eAAA;AANJ;;AAWA;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;AARF;AAWE;;EAEE,iBAAA;EAEA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;AAVJ;AAmBE;EACE,kBAAA;AAjBJ;AAoBI;EACE,iBAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAlBN;AA0BM;EACE,sBAAA;AAxBR;AA6BI;EACE,eAAA,EAAA,wDAAA;EACA,2DAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,2CAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,iBAAA;AA3BN;AA8BM;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AA5BR;AA+BQ;EACE,cAAA;AA7BV;AAiCQ;EACE,4BAAA;EACA,iBAAA;AA/BV;AAoCM;EACE,iBAAA;EACA,gBAAA;AAlCR;AAqCQ;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,0BAAA;AAnCV;AAsCU;EACE,mBAAA;AApCZ;AAuCU;EACE,mBAAA;EACA,8BAAA;EACA,kBAAA;AArCZ;AAyCU;EACE,mBAAA;AAvCZ;AA2CU;EACE,kBAAA;EACA,qBAAA;EACA,eAAA;AAzCZ;AA6CU;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AA3CZ;AA+CU;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AA7CZ;AAmDQ;EACE,UAAA;AAjDV;AAqDQ;EACE,mBAAA;AAnDV;AAuDQ;EACE,mBAAA;EACA,kBAAA;AArDV;AAyDQ;EACE,mBAAA;AAvDV;AA4DM;EACE,kBAAA;EACA,6BAAA;EACA,mBAAA;AA1DR;AA+DQ;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA7DV;AAiEQ;EACE,gBAAA;EACA,gBAAA;AA/DV;AAmEU;EACE,UAAA;AAjEZ;AAqEU;EACE,mBAAA;EACA,kBAAA;AAnEZ;AAuEU;EACE,mBAAA;EACA,kBAAA;AArEZ;AAyEU;EACE,mBAAA;AAvEZ;AA4EQ;EACE,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kCAAA;AA1EV;AA6EU;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,cAAA;AA3EZ;AA8EY;EACE,mBAAA;EACA,YAAA;AA5Ed;AAmFM;EACE,kBAAA;EACA,6BAAA;EACA,mBAAA;AAjFR;AAoFQ;EACE,WAAA;EACA,iBAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAlFV;AA4FU;EACE,wBAAA;AA1FZ;AA8FU;EACE,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA5FZ;;AAsGE;EACE,QAAA;AAnGJ;AAuGE;EACE,UAAA;AArGJ;AAyGE;EACE,gBAAA;EACA,gBAAA;AAvGJ;AA0GI;EACE,gBAAA;EACA,gBAAA;AAxGN;AA2GQ;EACE,WAAA;AAzGV;;AA0KA;EACE;IACE,UAAA;IACA,wCAAA;EAvKF;EA2KA;IACE,UAAA;IACA,iCAAA;EAzKF;AACF;AA6KA;EACE;IACE,UAAA;IACA,qBAAA;EA3KF;EA+KA;IACE,UAAA;IACA,mBAAA;EA7KF;AACF;AAiLA;EAGE;IAEE,YAAA;EAlLF;EAsLA;IACE,UAAA;EApLF;AACF;AAwLA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAtLF;AAyLE;EACE,eAAA;EACA,mBAAA;EACA,yCAAA;EACA,+BAAA;AAvLJ;AA2LE;EACE,eAAA;EACA,mBAAA;EACA,8CAAA;AAzLJ;;AA8LA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;AA3LF;AA8LE;EACE,iBAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AA5LJ;AA+LI;EACE,gCAAA;EACA,mBAAA;EACA,YAAA;AA7LN;;AAmMA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AAhMF;;AAoMA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AAjMF;AAoME;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAlMJ;AAsME;EACE,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,0BAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EAKA,gBAAA;EAGA,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;EAGA,yBAAA;EACA,2BAAA;AA1MJ;AA6MI;EACE,yBAAA;AA3MN;AA+MI;EACE,wDAAA;EACA,uBAAA;AA7MN;AAiNI;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;AA/MN;;AAqNA;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAlNF;;AAsNA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AAnNF;;AAuNA;EACE,iBAAA;AApNF;;AAwNA;EAGE;IAEE,uBAAA;EAxNF;EA4NA;IACE,yBAAA;EA1NF;EA8NA;IACE,yBAAA;EA5NF;EAgOA;IACE,yBAAA;EA9NF;AACF;AAkOA;EAGE;IAEE,wBAAA;EAnOF;EAuOA;IAEE,2BAAA;EAtOF;EA0OA;IACE,0BAAA;EAxOF;AACF;AA6OA;EACE;IACE,sBAAA;IACA,mBAAA;IACA,QAAA;EA3OF;EA+OI;IACE,SAAA;IACA,2BAAA;IACA,gBAAA;IACA,eAAA;EA7ON;EAiPQ;IACE,gBAAA;EA/OV;EAqPQ;IACE,eAAA;IACA,iBAAA;EAnPV;EA2PA;IACE,sBAAA;IACA,SAAA;IACA,oBAAA;EAzPF;EA6PA;IACE,uBAAA;EA3PF;AACF","sourcesContent":[".case-list-wrapper {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n\r\n.no-records-found {\r\n  text-align: center;\r\n  font-size: 1rem;\r\n  color: var(--text-color-medium);\r\n  padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);\r\n  background: var(--card-bg);\r\n  border-radius: 0.75rem;\r\n  border: 1px dashed var(--border-color);\r\n  // box-shadow: 0 2px 5px var(--shadow-light);\r\n  margin-top: calc(var(--spacing-unit) * 2);\r\n  grid-column: 1 / -1;\r\n}\r\n\r\n\r\n.filter-one-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n\r\n\r\n  input {\r\n    width: 49%;\r\n  }\r\n}\r\n\r\n\r\n.select-all-container {\r\n  margin-top: 10px;\r\n  margin-left: auto;\r\n  display: flex;\r\n  align-items: center;\r\n\r\n\r\n  label {\r\n    margin-left: 5px;\r\n    font-size: 15px;\r\n  }\r\n}\r\n\r\n\r\n.cases-options {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n\r\n\r\n  .manage-cases-btn,\r\n  .assign-cases-btn {\r\n    padding: 8px 18px;\r\n    // background: var(--update-main-color);\r\n    background: var(--primary-color);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 0.5rem;\r\n    cursor: pointer;\r\n\r\n\r\n    // &:hover {\r\n    //   opacity: 0.9;\r\n    // }\r\n  }\r\n\r\n\r\n  .lawyer-select-container {\r\n    position: relative;\r\n\r\n\r\n    .select-lawyer-btn {\r\n      padding: 8px 18px;\r\n      background: var(--success-color);\r\n      color: white;\r\n      border: none;\r\n      border-radius: 0.5rem;\r\n      cursor: pointer;\r\n      font-size: 14px;\r\n      font-weight: 500;\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 5px;\r\n\r\n\r\n      // &:hover {\r\n      //   background: #15803d;\r\n      // }\r\n\r\n\r\n      &:active {\r\n        transform: scale(0.98);\r\n      }\r\n    }\r\n\r\n\r\n    .lawyer-dropdown {\r\n      position: fixed; /* Changed from absolute to fixed like filter dropdown */\r\n      /* top and left will be set dynamically via inline styles */\r\n      background: white;\r\n      border: 1px solid #d1d5db;\r\n      border-radius: 8px;\r\n      box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\r\n      min-width: 320px;\r\n      max-width: 400px;\r\n      z-index: 1000;\r\n      max-height: 500px;\r\n      overflow: hidden;\r\n      animation: slideDown 0.2s ease-out;\r\n      margin-left: 44px;\r\n\r\n\r\n      .lawyer-search-input {\r\n        width: 100%;\r\n        padding: 12px 16px;\r\n        border: none;\r\n        border-bottom: 1px solid #e5e7eb;\r\n        font-size: 14px;\r\n        outline: none;\r\n        box-sizing: border-box;\r\n        background: #fafafa;\r\n\r\n\r\n        &::placeholder {\r\n          color: #9ca3af;\r\n        }\r\n\r\n\r\n        &:focus {\r\n          border-bottom-color: #3b82f6;\r\n          background: white;\r\n        }\r\n      }\r\n\r\n\r\n      .lawyer-options {\r\n        max-height: 180px;\r\n        overflow-y: auto;\r\n\r\n\r\n        .lawyer-option {\r\n          display: flex;\r\n          align-items: center;\r\n          padding: 12px 16px;\r\n          cursor: pointer;\r\n          border-bottom: 1px solid #f3f4f6;\r\n          transition: all 0.15s ease;\r\n\r\n\r\n          &:hover {\r\n            background: #f8fafc;\r\n          }\r\n\r\n          &.focused {\r\n            background: #dbeafe;\r\n            border-left: 3px solid #3b82f6;\r\n            padding-left: 13px;\r\n          }\r\n\r\n\r\n          &:last-child {\r\n            border-bottom: none;\r\n          }\r\n\r\n\r\n          input[type=\"checkbox\"] {\r\n            margin-right: 12px;\r\n            transform: scale(1.1);\r\n            cursor: pointer;\r\n          }\r\n\r\n\r\n          .lawyer-name {\r\n            font-size: 14px;\r\n            font-weight: 500;\r\n            margin-right: 8px;\r\n            color: #1f2937;\r\n            flex: 1;\r\n          }\r\n\r\n\r\n          .lawyer-email {\r\n            color: #6b7280;\r\n            font-size: 12px;\r\n            font-style: italic;\r\n          }\r\n        }\r\n\r\n\r\n        // Custom scrollbar\r\n        &::-webkit-scrollbar {\r\n          width: 6px;\r\n        }\r\n\r\n\r\n        &::-webkit-scrollbar-track {\r\n          background: #f1f1f1;\r\n        }\r\n\r\n\r\n        &::-webkit-scrollbar-thumb {\r\n          background: #c1c1c1;\r\n          border-radius: 3px;\r\n        }\r\n\r\n\r\n        &::-webkit-scrollbar-thumb:hover {\r\n          background: #a8a8a8;\r\n        }\r\n      }\r\n\r\n\r\n      .selected-lawyers {\r\n        padding: 12px 16px;\r\n        border-top: 1px solid #e5e7eb;\r\n        background: #f9fafb;\r\n        // max-height: 120px;\r\n        // overflow-y: auto;\r\n\r\n\r\n        h4 {\r\n          margin: 0 0 10px 0;\r\n          font-size: 13px;\r\n          color: #374151;\r\n          font-weight: 600;\r\n        }\r\n\r\n\r\n        .selected-lawyers-list {\r\n          max-height: 80px;\r\n          overflow-y: auto;\r\n\r\n\r\n          // Custom scrollbar for selected lawyers list\r\n          &::-webkit-scrollbar {\r\n            width: 4px;\r\n          }\r\n\r\n\r\n          &::-webkit-scrollbar-track {\r\n            background: #f1f1f1;\r\n            border-radius: 2px;\r\n          }\r\n\r\n\r\n          &::-webkit-scrollbar-thumb {\r\n            background: #c1c1c1;\r\n            border-radius: 2px;\r\n          }\r\n\r\n\r\n          &::-webkit-scrollbar-thumb:hover {\r\n            background: #a8a8a8;\r\n          }\r\n        }\r\n\r\n\r\n        .selected-lawyer-tag {\r\n          display: inline-flex;\r\n          align-items: center;\r\n          background: #dbeafe;\r\n          color: #1e40af;\r\n          padding: 4px 10px;\r\n          border-radius: 16px;\r\n          margin: 2px 4px 2px 0;\r\n          font-size: 12px;\r\n          font-weight: 500;\r\n          border: 1px solid #bfdbfe;\r\n          animation: tagAppear 0.2s ease-out;\r\n\r\n\r\n          button {\r\n            background: none;\r\n            border: none;\r\n            color: #1e40af;\r\n            margin-left: 6px;\r\n            cursor: pointer;\r\n            padding: 0 2px;\r\n            font-size: 14px;\r\n            font-weight: bold;\r\n            border-radius: 50%;\r\n            width: 16px;\r\n            height: 16px;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            transition: all 0.15s ease;\r\n            line-height: 1;\r\n\r\n\r\n            &:hover {\r\n              background: #1e40af;\r\n              color: white;\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n\r\n      .assign-action {\r\n        padding: 12px 16px;\r\n        border-top: 1px solid #e5e7eb;\r\n        background: #ffffff;\r\n\r\n\r\n        .assign-cases-final-btn {\r\n          width: 100%;\r\n          padding: 8px 18px;\r\n          background: var(--primary-color);\r\n          color: white;\r\n          border: none;\r\n          border-radius: 6px;\r\n          font-size: 14px;\r\n          font-weight: 600;\r\n          cursor: pointer;\r\n          transition: all 0.2s ease;\r\n\r\n\r\n          // &:hover:not(:disabled) {\r\n          //   background: #2563eb;\r\n          //   transform: translateY(-1px);\r\n          //   box-shadow: 0 4px 8px rgba(59, 130, 246, 0.3);\r\n          // }\r\n\r\n\r\n          &:active:not(:disabled) {\r\n            transform: translateY(0);\r\n          }\r\n\r\n\r\n          &:disabled {\r\n            background: #9ca3af;\r\n            cursor: not-allowed;\r\n            transform: none;\r\n            box-shadow: none;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n.filter-tab {\r\n  .filter-dropdown-box .filter-group {\r\n    gap: 5px;\r\n  }\r\n\r\n\r\n  .main-case-filter-dropdown-box .main-case-filter-filter-group {\r\n    width: 49%;\r\n  }\r\n\r\n  // Adjustments for customer role with fewer filter options\r\n  .filter-dropdown-box {\r\n    min-width: 320px;\r\n    max-width: 400px;\r\n    \r\n    // When there are fewer filters (customer role), adjust the layout\r\n    &.customer-filters {\r\n      min-width: 280px;\r\n      max-width: 350px;\r\n      \r\n      .page-filter {\r\n        .main-case-filter-filter-group {\r\n          width: 100%; // Full width for single status filter\r\n          //margin-bottom: 10px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // .main-case-filter-dropdown-box {\r\n  //   // Better spacing for date filters\r\n  //   .filter-group {\r\n  //     //margin-bottom: 15px;\r\n      \r\n  //     &:last-child {\r\n  //       //margin-bottom: 10px;\r\n  //     }\r\n      \r\n  //     label {\r\n  //       display: block;\r\n  //       margin-bottom: 8px;\r\n  //       font-weight: 500;\r\n  //       color: #374151;\r\n  //       font-size: 14px;\r\n  //     }\r\n      \r\n  //     select {\r\n  //       width: 100%;\r\n  //       padding: 8px 12px;\r\n  //       border: 1px solid #d1d5db;\r\n  //       border-radius: 6px;\r\n  //       font-size: 14px;\r\n  //       background-color: white;\r\n  //       cursor: pointer;\r\n        \r\n  //       &:focus {\r\n  //         outline: none;\r\n  //         border-color: #3b82f6;\r\n  //         box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n  //       }\r\n  //     }\r\n  //   }\r\n    \r\n  //   // Date filter styling\r\n  //   .filter-one-row {\r\n  //     display: flex;\r\n  //     gap: 10px;\r\n  //     align-items: center;\r\n      \r\n  //     input[type=\"date\"] {\r\n  //       flex: 1;\r\n  //       padding: 8px 12px;\r\n  //       border: 1px solid #d1d5db;\r\n  //       border-radius: 6px;\r\n  //       font-size: 14px;\r\n        \r\n  //       &:focus {\r\n  //         outline: none;\r\n  //         border-color: #3b82f6;\r\n  //         box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n  //       }\r\n  //     }\r\n  //   }\r\n  // }\r\n}\r\n\r\n\r\n@keyframes slideDown {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-10px) scale(0.95);\r\n  }\r\n\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0) scale(1);\r\n  }\r\n}\r\n\r\n\r\n@keyframes tagAppear {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.8);\r\n  }\r\n\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n\r\n@keyframes pulse {\r\n\r\n\r\n  0%,\r\n  100% {\r\n    opacity: 0.6;\r\n  }\r\n\r\n\r\n  50% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n\r\n.hammer-loader {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n\r\n\r\n  .hammer {\r\n    font-size: 40px;\r\n    margin-bottom: 16px;\r\n    animation: hammer 1s ease-in-out infinite;\r\n    transform-origin: bottom center;\r\n  }\r\n\r\n\r\n  .anvil {\r\n    font-size: 24px;\r\n    margin-bottom: 16px;\r\n    animation: anvil-shake 1s ease-in-out infinite;\r\n  }\r\n}\r\n\r\n\r\n.pagination-controls {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin: 20px 0;\r\n  gap: 10px;\r\n\r\n\r\n  button {\r\n    padding: 6px 12px;\r\n    background: var(--primary-color);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 10px;\r\n    cursor: pointer;\r\n    min-width: 80px;\r\n    text-align: center;\r\n\r\n\r\n    &:disabled {\r\n      background: var(--primary-color);\r\n      cursor: not-allowed;\r\n      opacity: 0.6;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n.page-filter {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-top: 5px;\r\n}\r\n\r\n\r\n.pagination-settings {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  padding: 7px 18px;\r\n  background-color: #E2E8F0;\r\n  border-radius: 6px;\r\n\r\n\r\n  label {\r\n    white-space: nowrap;\r\n    color: #1f2937;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n  }\r\n\r\n\r\n  #casesPerPageSelect {\r\n    border: none !important;\r\n    border-radius: 6px;\r\n    outline: none;\r\n    padding: 6px 32px 6px 12px;\r\n    background-color: white;\r\n    font-size: 14px;\r\n    color: #333;\r\n    cursor: pointer;\r\n    min-width: 70px;\r\n\r\n\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    appearance: none;\r\n\r\n\r\n    background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%23666'%3e%3cpath fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/%3e%3c/svg%3e\");\r\n    background-repeat: no-repeat;\r\n    background-position: right 10px center;\r\n    background-size: 16px;\r\n\r\n\r\n    transition: all 0.2s ease;\r\n    box-shadow: none !important;\r\n\r\n\r\n    &:hover {\r\n      background-color: #fafafa;\r\n    }\r\n\r\n\r\n    &:focus {\r\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;\r\n      background-color: white;\r\n    }\r\n\r\n\r\n    option {\r\n      border: none !important;\r\n      outline: none;\r\n      padding: 4px 8px;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n.filter-group .radio-group {\r\n  display: flex;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n\r\n.radio-option {\r\n  display: flex;\r\n  align-items: center;\r\n  font-size: 14px;\r\n  color: #333;\r\n}\r\n\r\n\r\n.radio-option input[type=\"radio\"] {\r\n  margin-right: 6px;\r\n}\r\n\r\n\r\n@keyframes hammer {\r\n\r\n\r\n  0%,\r\n  100% {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n\r\n  25% {\r\n    transform: rotate(-45deg);\r\n  }\r\n\r\n\r\n  50% {\r\n    transform: rotate(-90deg);\r\n  }\r\n\r\n\r\n  75% {\r\n    transform: rotate(-45deg);\r\n  }\r\n}\r\n\r\n\r\n@keyframes anvil-shake {\r\n\r\n\r\n  0%,\r\n  100% {\r\n    transform: translateX(0);\r\n  }\r\n\r\n\r\n  25%,\r\n  75% {\r\n    transform: translateX(-2px);\r\n  }\r\n\r\n\r\n  50% {\r\n    transform: translateX(2px);\r\n  }\r\n}\r\n\r\n\r\n// Mobile responsiveness\r\n@media (max-width: 768px) {\r\n  .cases-options {\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 8px;\r\n\r\n\r\n    .lawyer-select-container {\r\n      .lawyer-dropdown {\r\n        left: 50%;\r\n        transform: translateX(-50%);\r\n        min-width: 280px;\r\n        max-width: 90vw;\r\n\r\n\r\n        .selected-lawyers {\r\n          .selected-lawyers-list {\r\n            max-height: 60px;\r\n          }\r\n        }\r\n\r\n\r\n        .assign-action {\r\n          .assign-cases-final-btn {\r\n            font-size: 13px;\r\n            padding: 8px 12px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n\r\n  .page-filter {\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    align-items: stretch;\r\n  }\r\n\r\n\r\n  .pagination-settings {\r\n    justify-content: center;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
